import React, { useState } from "react";
import { useTranslation } from "react-i18next";
const Try = () => {
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [isTouched, setIsTouched] = useState(false);
  const { t, i18n } = useTranslation();
  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setIsValid(validateEmail(value));
    setIsTouched(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isValid) {
      alert(`Valid email: ${email}`);
      // Proceed with form submission
    } else {
      alert("Please enter a valid email address");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label htmlFor="email">Email:</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={handleEmailChange}
          onBlur={() => setIsTouched(true)}
          className={isTouched && !isValid ? "invalid" : ""}
        />
        {isTouched && !isValid && (
          <p className="error-message">Please enter a valid email address</p>
        )}
      </div>
      <button type="submit" disabled={!isValid}>
        Submit
      </button>
    </form>
  );
};

export default Try;
